import(/* webpackMode: "eager", webpackExports: ["HomeRedirect"] */ "/vercel/path0/components/auth/home-redirect.tsx");
